import { Button } from "primereact/button";
import "./Settings.css";
import editIcon from "../../assets/images/editLogo.png";
import { faPersonWalkingDashedLineArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Password } from "primereact/password";
import { useState } from "react";
import LogoutModal from "../../components/modals/logoutModal/LogoutModal";
import * as yup from "yup";
import { changePassword } from "../../services/auth.service";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { Avatar } from "primereact/avatar";
import { updateAgency, updateEmail } from "../../services/agency.service";
import { changeUserSuccess, logout } from "../../redux/userSlice";
import useToast from "../../context/toast.hook";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import { emptyAgencies } from "../../redux/agencies.slice";

const validationSchema = yup.object().shape({
  oldPassword: yup.string().required("Old Password is required"),
  newPassword: yup.string().required("New Password is required"),
  confirmPassword: yup
    .string()
    .required("Please retype your password.")
    .oneOf([yup.ref("newPassword")], "Your passwords do not match."),
});

const Settings = () => {
  const navigate = useNavigate();
  const { errorToast, successToast, toastRef } = useToast();
  const dispatch = useDispatch();
  const { currentUser, isAdmin } = useSelector((state) => state.user);
  const [toggleModal, setToggleModal] = useState(false);
  const [isEditable, setIsEditable] = useState({ open: false, name: "" });
  const [isEmailEditable, setEmailIsEditable] = useState({
    open: false,
    email: "",
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = (values) => {
    changePassword(values)
      .then(() => {
        successToast("Your password has been updated.");
        formik.resetForm();
      })
      .catch((error) => {
        errorToast(error);
      });
  };

  const handleUpdateName = () => {
    updateAgency(currentUser?._id, { name: isEditable?.name })
      .then((res) => {
        successToast("Your name has been updated.");
        dispatch(changeUserSuccess(res?.data?.user));
        setIsEditable({ open: false, name: "" });
      })
      .catch((error) => {
        errorToast(error);
        setIsEditable({ open: false, name: "" });
      });
  };

  const handleLogout = () => {
    navigate("/login");
    dispatch(logout());
    dispatch(emptyAgencies());
    localStorage.removeItem("authToken");
  };

  const handleUpdateEmail = () => {
    updateEmail({ email: isEmailEditable?.email })
      .then((res) => {
        successToast(
          "Your Email has been updated. Please check for new password"
        );
        setEmailIsEditable({ open: false, email: "" });
        setTimeout(() => {
          handleLogout();
        }, [3000]);
      })
      .catch((error) => {
        errorToast(error);
        setEmailIsEditable({ open: false, email: "" });
      });
  };

  const handleComposeClick = () => {
    const to = "support@opta.com";
    const mailtoUrl = `mailto:${encodeURIComponent(to)}`;
    window.location.href = mailtoUrl;
  };
  return (
    <>
      <Toast ref={toastRef} />
      {toggleModal && <LogoutModal toggleModal={setToggleModal} />}

      <div className="settingsHeader">
        <strong>
          <span className="accountHeading">My Account</span>
        </strong>
        <div className="logoutInner" style={{ display: "flex", gap: "10px" }}>
          <Button
            label="Contact Support"
            severity="danger"
            onClick={handleComposeClick}
            style={{
              // backgroundColor: "#F74A4A",
              border: "0px",
              width: "140px",
              whiteSpace: "nowrap",
            }}
          />
          <Button
            label="Logout"
            onClick={() => {
              setToggleModal(true);
            }}
            severity="danger"
            style={{
              backgroundColor: "#F74A4A",
              border: "0px",
              width: "110px",
            }}
          />
        </div>
      </div>

      <div className="profileMain">
        <div className="editProfile">
          <br />
          <Avatar
            label={currentUser?.name?.charAt(0)?.toUpperCase() || "A"}
            size="xlarge"
            shape="circle"
            style={{ backgroundColor: "#1c9894", color: "#ffffff" }}
          />
        </div>
        <div className="profileDetails">
          <div className="profileRow">
            {isEditable?.open ? (
              <input
                defaultValue={isEditable?.name}
                onChange={(e) =>
                  setIsEditable({ ...isEditable, name: e.target.value })
                }
              />
            ) : (
              <span className="userName">{currentUser?.name || "User"}</span>
            )}
            {isEditable?.open ? (
              <Button
                className="checkBtn"
                style={{
                  width: "26px",
                  height: "26px",
                  backgroundColor: "#1C9894",
                  display: "flex",
                  justifyContent: "center",
                  border: "0",
                  marginLeft: "10px",
                }}
                onClick={handleUpdateName}
              >
                <i className="pi pi-check" />
              </Button>
            ) : (
              <Button
                style={{
                  width: "26px",
                  height: "26px",
                  backgroundColor: "white",
                  display: "flex",
                  justifyContent: "center",
                  border: "0",
                  marginLeft: "10px",
                }}
                onClick={() =>
                  setIsEditable({ open: true, name: currentUser?.name })
                }
                disabled={isAdmin && currentUser?.role !== "admin"}
              >
                <img src={editIcon} alt="logo" />
              </Button>
            )}
          </div>
          <div className="profileRow">
            <span className="userEmail">Email:</span>

            {isEmailEditable?.open ? (
              <input
                defaultValue={isEmailEditable?.email}
                onChange={(e) =>
                  setEmailIsEditable({
                    ...isEmailEditable,
                    email: e.target.value,
                  })
                }
              />
            ) : (
              <span className="greyEmail">
                {currentUser?.email || "email@opta.io"}
              </span>
            )}
            {isEmailEditable?.open ? (
              <Button
                className="checkBtn"
                style={{
                  width: "26px",
                  height: "26px",
                  backgroundColor: "#1C9894",
                  display: "flex",
                  justifyContent: "center",
                  border: "0",
                  marginLeft: "10px",
                }}
                onClick={handleUpdateEmail}
              >
                <i className="pi pi-check" />
              </Button>
            ) : (
              <Button
                style={{
                  width: "26px",
                  height: "26px",
                  backgroundColor: "white",
                  display: "flex",
                  justifyContent: "center",
                  border: "0",
                  marginLeft: "10px",
                }}
                onClick={() =>
                  setEmailIsEditable({ open: true, email: currentUser?.email })
                }
                disabled={isAdmin && currentUser?.role !== "admin"}
              >
                <img src={editIcon} alt="logo" />
              </Button>
            )}
          </div>
        </div>
      </div>
      <br />
      <br />
      <hr />

      <br />
      <span className="lorumText"></span>
      <br />
      <span className="lorumText"></span>
      <strong>
        <span className="changePassText">Change Password</span>
      </strong>

      <div className="passwordBox1">
        <label htmlFor="password" className="block text-800">
          <strong>Current Password</strong>
        </label>
        <Password
          id="oldPassword"
          aria-describedby="password-help"
          className="w-full block pass-wid mt-2"
          name="oldPassword"
          value={formik.values.oldPassword}
          onChange={formik.handleChange}
          toggleMask
          style={{ color: "#1C9894" }}
          disabled={isAdmin && currentUser?.role !== "admin"}
        />
        {formik.touched.oldPassword && formik.errors.oldPassword ? (
          <small id="password-help" className="p-error block">
            {formik.errors.oldPassword}
          </small>
        ) : null}
      </div>
      <div className="passwordBox1">
        <label htmlFor="password" className="block text-800">
          <strong>New Password</strong>
        </label>
        <Password
          id="newPassword"
          aria-describedby="password-help"
          className="w-full block pass-wid mt-2"
          name="newPassword"
          value={formik.values.newPassword}
          onChange={formik.handleChange}
          toggleMask
          style={{ color: "#1C9894" }}
          disabled={isAdmin && currentUser?.role !== "admin"}
        />
        {formik.touched.newPassword && formik.errors.newPassword ? (
          <small id="password-help" className="p-error block">
            {formik.errors.newPassword}
          </small>
        ) : null}
      </div>
      <div className="passwordBox1">
        <label htmlFor="password" className="block text-800">
          <strong>Confirm Password</strong>
        </label>
        <Password
          id="confirmPassword"
          aria-describedby="password-help"
          className="w-full block pass-wid mt-2"
          name="confirmPassword"
          value={formik.values.confirmPassword}
          onChange={formik.handleChange}
          toggleMask
          style={{ color: "#1C9894" }}
          disabled={isAdmin && currentUser?.role !== "admin"}
        />
        {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
          <small id="password-help" className="p-error block">
            {formik.errors.confirmPassword}
          </small>
        ) : null}
      </div>
      <Button
        label="Change Password"
        onClick={formik.handleSubmit}
        style={{ border: "0px", minWidth: "110px", marginTop: "20px" }}
        disabled={isAdmin && currentUser?.role !== "admin"}
      />
    </>
  );
};

export default Settings;
